import React from "react";
import {
  FormControl,
  FormLabel,
  FormHelperText,
  RadioGroup as MuiRadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import PropTypes from "prop-types";

RadioGroup.propTypes = {
  item: PropTypes.object.isRequired,
  value: PropTypes.any,
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  showErrorText: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default function RadioGroup(props) {
  const {
    item,
    value = false,
    error = null,
    onChange,
    showErrorText = false,
    disabled = false,
  } = props;

  let helperText = "";
  if (showErrorText) helperText = error;
  return (
    <FormControl {...(error && { error: true })}>
      <FormLabel>{item.label}</FormLabel>
      <MuiRadioGroup
        row
        name={item.name}
        value={value || false}
        onChange={onChange}
      >
        {item.options.map((sitem) => (
          <FormControlLabel
            disabled={disabled}
            key={sitem.key}
            value={sitem.key}
            control={<Radio />}
            label={sitem.label}
          />
        ))}
      </MuiRadioGroup>
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  );
}
